module.exports = __webpack_public_path__ + "img/img3.7e62be0b.jpg";